module.exports = __webpack_public_path__ + "img/393-5f39a7.png";